import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { OwnershipTypeDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';


@Component({
  selector: 'cradua-ownershiptype-container',
  templateUrl: './ownershiptype-container.component.html',
  styleUrls: ['./ownershiptype-container.component.scss']
})
export class OwnershiptypeContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  ownershiptypes$: Observable<OwnershipTypeDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("OwnershipType");
    this.ownershiptypes$ = this.gatwayFacade.loadGateway("OwnershipType");
    this.ownershiptypes$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteOwnershipType(deletedValue: any) {
    this.gatwayFacade.remove("OwnershipType", deletedValue);
    // this.store.dispatch(OwnershipTypeStoreActions.removeOwnershipType({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitOwnershipType(formValue: any) {
    console.log("form value: ", formValue);
    formValue.OwnershipTypes = formValue.OwnershipTypes.reverse();
    event.preventDefault();
    const pullData = formValue.OwnershipTypes;
    //const newPullData = formValue.OwnershipTypees;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllOwnershipType = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllOwnershipType.push(pullData[i]);
    }
  }

// check if the addAllOwnershipType array is not empty, then dispatch the data to the store
   if(addAllOwnershipType.length !== 0) {
    this.gatwayFacade.add('OwnershipType', addAllOwnershipType);
    // this.store.dispatch(OwnershipTypeStoreActions.addOwnershipType({newOwnershipType: addAllOwnershipType}));

   }

// dispatch update data to the store
this.gatwayFacade.update('OwnershipType', allUpdates, ['id']);
    // this.store.dispatch(OwnershipTypeStoreActions.updateOwnershipType({updateOwnershipType: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}


